import { useEffect, useState } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import FemaleIcon from '../../../../../static/images/GENDER_FEMALE.png';
import MaleIcon from '../../../../../static/images/GENDER_MALE.png';
import XmaleIcon from '../../../../../static/images/GENDER_X.png';
import { DropDownIcon, DropUpIcon, EditIcon } from '../../../../../components/Icon';
import ElderlyHomeInfo from '../../../../../components/ElderlyHomeInfo';
import Text from '../../../../../components/Text';
import { ReactComponent as BedIcon } from '../../../../../static/images/BedIcon.svg';
import { conditional, initValue } from '../../../../../utils';
import admissionUtil from '../../../../../utils/admissionUtil';
import StatusIcon from '../../../../BedStatus/newComponents/Icons/StatusBed';
import BusStopPopup from '../../Popups/BusStopPopup';
import { LoginPop } from '../../../../../components/Login';
import { LOGIN_INFO } from '../../../../../comm/constant';
import Barcode from './Barcode';

const useStyles = makeStyles((theme) => ({
  edit: {
    width: '2.25rem',
    height: '2.25rem',
    borderRadius: '10px',
    backgroundColor: '#538FFF',
  },
  editIcon: {
    fontSize: '1.125rem',
    color: '#FFF',
  },
  dropdown: {
    width: '1.5rem',
    height: '1.5rem',
  },
  dropdownIcon: {
    fontSize: '0.938rem',
    color: '#538FFF',
  },
  genderIcon: ({ iconSize, genderColor }) => ({
    width: iconSize,
    color: genderColor,
  }),
  femaleIcon: ({ iconSize, genderColor }) => ({
    width: '1.9rem',
    color: genderColor,
  }),
  age: ({ genderColor }) => ({
    color: genderColor,
    fontSize: '1rem',
    fontFamily: 'NotoSans-Bold',
    textAlign: 'center',
  }),
  positionIcon: {
    width: '0.875rem',
    height: '1rem',
  },
  barcodeBox: {
    marginTop: '0.785rem',
    width: '100%',
    maxWidth: '15rem',
    minWidth: 0,
    boxSizing: 'border-box',
    border: '1px solid #D7DCE5',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
  },
  barcodeSvg: {
    display: 'block',
    width: '100%',
    height: 'auto',
    maxHeight: '5.5rem',
  },
  patientRoot: {
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'hidden',
  },
}));

export const EditUI = ({ open = false, handleEdit, busStopInfo, hold, admissionType = 'EADM', gender, eaId }) => {
  const classes = useStyles({});
  const [popup, setPopup] = useState(false);
  const [isShowLoginPop, setIsShowLoginPop] = useState(false);

  const handleOpenDetail = () => {
    setPopup(true);
  };

  const handleCloseDetail = () => {
    setPopup(false);
  };

  const handleClickEdit = async () => {
    try {
      const loginInfo = JSON.parse(localStorage.getItem(LOGIN_INFO));

      if (loginInfo?.flag) {
        const tokenExp = loginInfo.tokenExp;
        if (moment(tokenExp).isAfter(moment())) {
          handleEdit();
          return;
        }
      }
      setIsShowLoginPop(true);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gridGap="0.7rem">
      <ButtonBase className={classes.edit} onClick={handleClickEdit}>
        <EditIcon className={classes.editIcon} />
      </ButtonBase>

      {admissionType === 'EADM' && (
        <ButtonBase className={classes.dropdown} onClick={handleOpenDetail}>
          {open ? <DropUpIcon className={classes.dropdownIcon} /> : <DropDownIcon className={classes.dropdownIcon} />}
        </ButtonBase>
      )}
      {popup && (
        <BusStopPopup
          busStopInfo={busStopInfo}
          handleClose={handleCloseDetail}
          hold={hold}
          gender={gender}
          eaId={eaId}
        />
      )}
      {isShowLoginPop && (
        <LoginPop
          closehandle={() => setIsShowLoginPop(false)}
          submitHandle={() => setIsShowLoginPop(false)}
          tokenExpiration={true}
        />
      )}
    </Box>
  );
};

export const getGenderColor = (gender) => {
  switch (gender) {
    case 'F':
      return '#FF8181';
    case 'M':
      return '#538FFF';
    case 'X':
      return '#7B80FF';

    default:
      return '';
  }
};

export const PatientUI = ({
  iconSize = '2.3rem',
  iconBoxSize = '3.3rem',
  caseNo,
  bedNo,
  chiName,
  engName,
  gender,
  age,
  measure,
  showBarcode = false,
  ehAddrInfo = null,
}) => {
  const classes = useStyles({ iconSize, iconBoxSize, genderColor: getGenderColor(gender) });
  const isLogin = useSelector((state) => state.loginInfo.flag);
  const name = admissionUtil.useGetName({ chiName, engName, loginFlag: isLogin });

  useEffect(() => {
    // 重新检测UI的高度
    if (_.isFunction(measure)) {
      measure();
    }
  }, [measure, name, showBarcode]);

  return (
    <Box className={classes.patientRoot}>
      <Box display="inline-flex" gridGap="0.62rem">
        <Box>
          <Box display="flex" alignItems="center" justifyContent="center">
            {gender === 'M' && <img className={classes.genderIcon} src={MaleIcon} alt="MaleIcon" />}
            {gender === 'F' && <img className={classes.femaleIcon} src={FemaleIcon} alt="FemaleIcon" />}
            {gender === 'X' && <img className={classes.genderIcon} src={XmaleIcon} alt="XmaleIcon" />}
          </Box>
          <div className={classes.age}>{initValue(age, '')}</div>
        </Box>
        <Box display="flex" flexDirection="column" gridGap="0.25rem">
          <Text fontFamily="NotoSans-Bold" color={getGenderColor(gender)}>
            {initValue(caseNo, '')}
          </Text>
          <Box display="flex" gridGap="0.3rem">
            <ElderlyHomeInfo ehAddrInfo={ehAddrInfo} />
            <Text color="#2E4469" fontSize="16px" fontFamily="HA_MingLiu, NotoSans-Medium">
              {initValue(name, '')}
            </Text>
          </Box>
          {bedNo && (
            <Box display="flex" alignItems="center" gridGap="0.25rem">
              <BedIcon className={classes.positionIcon} />
              <Text fontSize="0.75rem">{initValue(bedNo, '')}</Text>
            </Box>
          )}
        </Box>
      </Box>
      {showBarcode && (
        <Box className={classes.barcodeBox}>
          <Barcode barcodeNo={caseNo} className={classes.barcodeSvg} />
        </Box>
      )}
    </Box>
  );
};

export const WardUI = ({ admWardInfo, gender, status }) => {
  if (!admWardInfo) {
    return null;
  }
  return (
    admWardInfo &&
    status !== 'Pending' && (
      <Box display="flex" gridGap="0.62rem">
        <StatusIcon
          typeName={admWardInfo.bedAssignedBedNo ? 'O' : 'TBC'}
          bedNo={admWardInfo.bedAssignedBedNo}
          ward={admWardInfo.bedAssignedWardCd}
          genderType={gender}
        />
        <Box display="flex" flexDirection="column" gridGap="0.25rem">
          <Text fontFamily="NotoSans-Bold" color={getGenderColor(gender)}>
            {admWardInfo.admRegHn}
          </Text>
          <Text color="#2E4469" fontSize="1.3rem">{`${admWardInfo.hospCode} ${admWardInfo.wardName}`}</Text>
        </Box>
      </Box>
    )
  );
};

export const AckInfo = ({ ackDate, ackBy, adTicketType }) => {
  return (
    <Box display="flex" flexDirection="column" gridGap="0.5rem">
      <Text fontSize="0.875rem" color="#2E4469">
        {conditional(ackDate, moment(ackDate).format('YYYY-MM-DD HH:mm'), '')}
      </Text>
      <Text fontSize="0.875rem" color="#2E4469">
        {conditional(ackBy, ackBy, '')}
      </Text>
      <Text fontSize="0.875rem" color="#2E4469">
        {conditional(adTicketType, adTicketType, '')}
      </Text>
    </Box>
  );
};
